<template>
    <el-container id="tab">
        <el-aside width="240px">
            <el-card class="box-card" shadow="never">
                <div slot="header">
                    <span>主品信息</span>
                </div>
                <el-form ref="queryFormRef" :rules="queryRules" :model="queryForm" label-width="10px" size="small">
                    <el-form-item label=" " prop="warehouse.selected">
                        <select-multiple :is-clear="false" v-bind:select-data="queryForm.warehouse" suffixText="盘点中" :change="warehouseChange"></select-multiple>
                    </el-form-item>
                    <el-form-item label=" " prop="product.selected">
                        <select-multiple :is-clear="false" v-if="queryForm.warehouse.selected.value" :select-data="queryForm.product" :change="productChange" :isSlot="true">
                            <template #header>
                                <li class="el-select-group__title" style="color: #000; font-weight: bold; font-size: 14px;">
                                    <span style="width: 180px;display: inline-block;">主品</span>
                                    <span style="width: 180px;display: inline-block;">组合品</span>
                                </li>
                            </template>
                            <template v-slot:default='slotProps'>
                                <span style="width: 180px;display: inline-block;overflow: hidden;text-overflow:ellipsis;">{{ slotProps.item.mainItemName }}</span>
                                <span style="width: 180px;display: inline-block;overflow: hidden;text-overflow:ellipsis;">{{ slotProps.item.composeItemName }}</span>
                            </template>
                        </select-multiple>
                        <div v-else style="width: 100%; height: 32px; line-height: 32px; border-radius: 4px; padding: 0 15px; color: #C0C4CC;border: 1px solid #DCDFE6;" @click="selectClick">请选择商品名称</div>
                    </el-form-item>
                    <el-form-item>
                        <el-date-picker format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" style="width: 100%;" v-model="queryForm.productionDate.selected" type="date" placeholder="生产日期" @change="warehouseChange"></el-date-picker>
                    </el-form-item>
                    <el-form-item label=" ">
                        <el-input :placeholder="'库存： ' + (mainProduct.onhandQtyStr ? mainProduct.onhandQtyStr : '')" disabled>
                        </el-input>
                    </el-form-item>
                    <el-form-item label=" " prop="qty.selected">
                        <el-input v-model="queryForm.qty.selected" style="width: 70%" placeholder="请输入数量" @blur="inputBlur" @input="inputChange"></el-input>
                        <el-input style="width: 30%; margin-left: 10px;" :placeholder="mainProduct.unitName ? mainProduct.unitName : '单位'" disabled></el-input>
                    </el-form-item>
                    <el-form-item label=" " prop="remark.selected">
                        <el-input v-model="queryForm.remark.selected" clearable placeholder="请输入备注"></el-input>
                    </el-form-item>
                    <el-form-item label=" " v-if="allowCostPrice">
                        <el-input v-model="mainProduct.costPrice" placeholder="主商品成本价" disabled></el-input>
                    </el-form-item>
                    <el-form-item label=" " v-if="allowCostPrice">
                        <el-input v-model="mainProduct.TotalAmt" placeholder="主商品成本总额" disabled></el-input>
                    </el-form-item>
                    <!-- <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                        <el-button @click="onReset">重置</el-button>
                    </el-form-item> -->
                </el-form>
            </el-card>
        </el-aside>
        <el-main>
            <div class="table" v-loading="tableLoading">
                <el-table class="tb-edit" ref="table" :data="tableData" border stripe height="100%" max-height="100%" style="width: 100%" @cell-click="tableCellClick">
                    <el-table-column type="index" align="center" fixed width="30"></el-table-column>
                    <el-table-column prop="itemName" label="组合品" align="center" fixed min-width="140px"></el-table-column>
                    <el-table-column prop="unitName" align="center" label="单位" min-width="100"></el-table-column>
                    <el-table-column label="生产日期" align="center" prop="productionDate" min-width="140">
                        <template #default="{ row, column }">
                            <select-multiple v-if="row.itemID && row.isShowProductionDate" :is-clear="false" :select-data="productionDate" :isSlot="true" v-focus :change="(val) => { productionDateChange(val, row) }" :visible-change="(visible) => {productionDateVisibleChange(visible, row, column)}">
                                <template #header>
                                    <li class="el-select-group__title" style="color: #000; font-weight: bold; font-size: 14px;">
                                        <span style="width: 100px;display: inline-block;">生产日期</span>
                                        <span style="width: 100px;display: inline-block;">库存</span>
                                    </li>
                                </template>
                                <template v-slot:default='slotProps'>
                                    <span style="width: 100px;display: inline-block;overflow: hidden;text-overflow:ellipsis;">{{ slotProps.item.productionDate || '无' }}</span>
                                    <span style="width: 100px;display: inline-block;overflow: hidden;text-overflow:ellipsis;">{{ slotProps.item.onhandQtyStr }}</span>
                                </template>
                            </select-multiple>
                            <span v-else>{{row.productionDate}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="onhandQtyStr" align="center" label="库存" min-width="120"></el-table-column>
                    <el-table-column prop="costPrice" align="center" v-if="allowCostPrice" label="成本价" min-width="100"></el-table-column>
                    <el-table-column prop="TotalAmt" align="center" v-if="allowCostPrice" label="成本总额" min-width="100"></el-table-column>
                    <el-table-column label="数量" align="center" prop="qty" min-width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.itemName">{{Number((Number(scope.row.qty) || 0).toFixedRoundUp(2))}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" align="center" min-width="120">
                        <template slot-scope="scope">
                            <div v-if="scope.row.isShowRemark">
                                <el-input size="small" v-model="scope.row.remark" v-focus @blur="scope.row.isShowRemark = false"></el-input>
                            </div>
                            <span v-else>{{scope.row.remark}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="main_footer">
                <div style="width: 50%;"><template v-if="allowCostPrice">组合商品成本总额合计：<span class="text">{{total.sum}}</span>元，成本差额<span class="text" style="font-size: 20px">{{total.cut}}</span>元</template></div>
                <el-button type="primary" @click="submit">提交</el-button>
            </div>
        </el-main>
    </el-container>
</template>
<script>
import { toFixedRe } from '@/assets/js/common.js'
export default {
    name: "InvMakeQuery",
    components: {},
    data() {
        return {
            isCollapse: false,
            queryForm: {
                warehouse: { submitName: 'warehouseID', selected: [], valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择仓库', request: { url: '/Account/wareHouseDefine/selectWarehouseFreezeForAuth.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                product: { submitName: 'itemID', selected: [], valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择商品名称', request: { url: '/Account/itemComposeDefineVue/selectItemComposeList.html', type: 'post', params: { page: 1, size: 5 }, text: 'mainItemName', value: 'seqNo', } },
                qty: { selected: '' },
                remark: { selected: '' },
                productionDate: { selected: '' },
            },
            queryRules: {
                'warehouse.selected': [
                    { required: true, message: '请选择仓库', trigger: 'blur' }
                ],
                'product.selected': [
                    { required: true, message: '请选择商品', trigger: 'blur' }
                ],
                'qty.selected': [
                    { required: true, message: '请输入数量', trigger: 'blur' }
                ]
            },
            tableData: this.pushItem(),
            mainProduct: {},
            tableLoading: false,
            total: {
                sum: 0.00, //总额合计
                cut: 0.00, //差额
            },
            allowCostPrice: false,
            priceArgs: {
                url: "/Account/dataSearchVue/getUserAllowCostPrice.html",
                code: 'isAllocateDisassembly'
            },
            productionDate: { submitName: 'warehouseID', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择生产日期', request: { url: '/Account/invItemComposeVue/selectProductionDateComposeListByItemId.html', type: 'post', params: { page: 1, size: 5 }, text: 'onhandQtyStr', value: 'productionDate' } },
        }
    },
    directives: {
        focus: {
            inserted: function(el) {
                el.querySelector('input').onfocus = function(e) {
                    e.currentTarget.select()
                }
                el.querySelector('input').focus()
            }
        }
    },
    watch: {
        tableData(val) {
            val.forEach((item, index) => {
                item['lineNum'] = index + 1
            })
        },
    },
    created() {
        // this.getTableData()
        // console.log(top.indexVm.$store.state)
        // this.allowCostPrice = top.indexVm.$store.state.power.allowCostPrice == 'Y'
        this.allowCostPrice = this.$store.state.power.allowCostPrice == 'Y'
        if (this.$store.state.power.enterpriseVersion >= 100) {
            this.getPriceShow()
        }
        let unwatch = this.$watch('$store.state.power', (val) => {
            this.allowCostPrice = this.$store.state.power.allowCostPrice == 'Y'
            if(val.enterpriseVersion >= 100){
                this.getPriceShow()
            }
            unwatch()
            this.$nextTick(() => {
                this.$refs["table"].doLayout();
            });
        })
    },
    methods: {
        async getPriceShow() {
            const { data: res } = await this.$http.post(this.priceArgs.url, this.Qs.stringify(this.priceArgs))
            console.log(res.result)
            this.allowCostPrice = res.result == 'Y'
            this.$nextTick(() => {
                this.$refs["table"].doLayout();
            });
        },
        async getTableData(seqNo) {
            this.tableLoading = true
            let url = '/Account/invItemComposeVue/selectInvItemComposeList.html'
            try {
                const { data: res } = await this.$http.post(url, this.Qs.stringify({ seqNo: seqNo, warehouseID: this.queryForm.warehouse.selected.value, productionDate: this.queryForm.productionDate.selected }))
                this.tableLoading = false
                if (res.code != 'success') return this.$message.error(res.message)
                let { mainList, composeList } = JSON.parse(res.result)
                this.mainProduct = mainList[0]
                this.queryForm.qty.selected = this.mainProduct.qty ? Number(this.mainProduct.qty) : 1
                this.mainProduct.TotalAmt = toFixedRe(Number(Number(this.queryForm.qty.selected) * Number(this.mainProduct.costPrice)), 2)
                this.mainProduct.billPrice = Number(this.mainProduct.costPrice).toFixedRoundUp(2)
                this.mainProduct.billQty = this.mainProduct.qty
                this.mainProduct.originalQty = this.mainProduct.qty
                this.mainProduct.productionDate = this.queryForm.productionDate.selected
                console.log(composeList)
                let sum = 0
                composeList.forEach((item, index) => {
                    item.TotalAmt = Number(Number(item.qty) * Number(item.costPrice)).toFixedRoundUp(2)
                    item.billQty = item.qty
                    item.originalQty = item.qty
                    item.billPrice = item.costPrice
                    sum = Number(sum + Number(Number(item.qty) * Number(item.costPrice)))
                    this.$set(this.tableData, index, item)
                })
                this.total.sum = sum.toFixedRoundUp(2)
                this.total.cut = Number(Number(this.mainProduct.TotalAmt).toFixedRoundUp(2) - Number(sum).toFixedRoundUp(2)).toFixedRoundUp(2)
                console.log(sum)
            } catch (e) {
                console.log(e)
                this.tableLoading = false
            }
        },
        onSubmit() {},
        onReset() {},
        warehouseChange(val) {
            if (val && this.queryForm.product.selected.value) {
                this.getTableData(this.queryForm.product.selected.value)
            }
        },
        productChange(val) {
            console.log(val)
            if (val) {
                this.getTableData(val.seqNo)
            }
        },
        selectClick() {
            if (!this.queryForm.warehouse.selected.value) {
                return this.$message({
                    showClose: true,
                    message: '请先选择仓库',
                    type: 'warning'
                })
            }
        },
        inputChange(val) {
            if (val) {
                val = val.replace(/[^\d]/g, '')
                this.queryForm.qty.selected = val
            }
        },
        inputBlur() {
            this.mainProduct.qty = this.queryForm.qty.selected
            this.mainProduct.billQty = this.mainProduct.qty
            if (this.mainProduct.TotalAmt) this.mainProduct.TotalAmt = toFixedRe(Number(this.queryForm.qty.selected) * Number(this.mainProduct.costPrice), 2)
            let sum = 0
            this.tableData.forEach((item) => {
                if (item.itemName) {
                    item.qty = Number(Number(item.originalQty) * (Number(this.queryForm.qty.selected) / Number(this.mainProduct.originalQty)).toFixedRoundUp(2))
                    item.billQty = item.qty
                    item.billPrice = item.costPrice
                    item.TotalAmt = Number(Number(item.qty) * Number(item.costPrice)).toFixedRoundUp(2)
                    sum = sum + Number(Number(item.qty) * Number(item.costPrice))
                }
            })
            this.total.sum = sum.toFixedRoundUp(2)
            this.mainProduct.TotalAmt = this.mainProduct.TotalAmt ? this.mainProduct.TotalAmt : 0
            this.total.cut = Number(Number(this.mainProduct.TotalAmt).toFixedRoundUp(2) - Number(sum).toFixedRoundUp(2)).toFixedRoundUp(2)
        },
        titleCase(str) {
            return str.replace(/( |^)[a-z]/g, (L) => L.toUpperCase())
        },
        tableCellClick(row, { property }) {
            if (property) {
                if (property == 'productionDate') {
                    this.productionDate.request.params['itemID'] = "'" + row.itemID + "'"
                    this.productionDate.request.params['seqNo'] = this.queryForm.product.selected.seqNo
                    this.productionDate.request.params['warehouseID'] = this.queryForm.warehouse.selected.value
                    
                }
                this.$set(row, 'isShow' + this.titleCase(property), true)
                console.log(row['isShow' + this.titleCase(property)])
            }
        },
        productionDateVisibleChange(visible, row, column) {
            let { property } = column
            if (!visible) {
                row['isShow' + this.titleCase(property)] = false
            }
        },
        productionDateChange(val, row) {
            let { productionDate, onhandQtyStr } = val
            row['onhandQtyStr'] = onhandQtyStr
            row['productionDate'] = productionDate
        },
        pushItem(length) {
            const tempItem = []
            if (!length) length = 10
            for (let i = 0; i < length; i++) {
                tempItem.push({})
            }
            return tempItem
        },
        async submit() {
            if (!this.queryForm.warehouse.selected.value) {
                return this.$message({
                    showClose: true,
                    message: '请先选择仓库',
                    type: 'warning'
                })
            }
            if (!this.queryForm.product.selected.value) {
                return this.$message({
                    showClose: true,
                    message: '请先选择主商品',
                    type: 'warning'
                })
            }
            if (!this.queryForm.qty.selected) {
                return this.$message({
                    showClose: true,
                    message: '请先输入数量',
                    type: 'warning'
                })
            }
            // let currTab = '',
            //     title = ''
            // if (top.$('#tabspanel .tabs-selected').text()) {
            //     currTab = top.$('#tabspanel').tabs('getSelected') || ''
            //     title = top.$('#tabspanel .tabs-selected').text() || ''
            // } else {
            //     title = top.getTabName() || ''
            //     currTab = top.getTabName() || ''
            // }
            let headInfo = {
                outWarehouseID: this.queryForm.warehouse.selected.value,
                outWarehouseName: this.queryForm.warehouse.selected.text,
                inWarehouseID: this.queryForm.warehouse.selected.value,
                inWarehouseName: this.queryForm.warehouse.selected.text,
                remark: this.queryForm.remark.selected
            }
            let mainItemList = []
            mainItemList.push(this.mainProduct)
            let composeItemList = [...this.tableData].filter(item => item.itemID)
            console.log(headInfo)
            console.log(mainItemList)
            console.log(composeItemList)
            const loading = this.$loading({
                lock: true,
                text: '提交中，请耐心等待',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            let url = '/Account/invItemComposeVue/addInvItemComposeVue.html'
            let submitInfo = {
                headInfo: JSON.stringify(headInfo),
                mainItemList: JSON.stringify(mainItemList),
                composeItemList: JSON.stringify(composeItemList)
            }
            const { data: res } = await this.$http.post(url, this.Qs.stringify(submitInfo))
            loading.close()
            if (res.code != 'success') return this.$message.error(res.message)
            this.$message.success(res.message)
            top.refreshTabWithUrl(`/templates/vue-account/dist/index.htm#/invMakeQuery`, currTab)
        }
    }
};
</script>
<style scoped lang="less">
#tab {

    // height: calc(100vh - 20px);
    .el-aside {
        height: 100%;
        max-height: 500px;

        .box-card {
            height: calc(100% - 2px);

            ::v-deep .el-card__header {
                padding: 8px 20px;
                height: 33px;
            }

            ::v-deep .el-card__body {
                padding: 6px;
                height: calc(100% - 33px - 12px);
                overflow-y: auto;

                .el-form {
                    height: calc(100%);
                }
            }

            /deep/.el-form-item__content {
                display: flex;
                justify-content: center;
                align-items: center;
            }

            /deep/.el-input-number {
                width: 100%;

                input {
                    text-align: left;
                }
            }

            /deep/.el-input.is-disabled {
                .el-input__inner {
                    color: #606266;
                }

                .el-input__inner::-webkit-input-placeholder {
                    color: #606266;
                }
            }
        }

        .select_multiple {
            ::v-deep .el-select__tags {
                max-height: 80px;
                overflow-y: auto;
                overflow-x: hidden;
            }
        }
    }

    .el-main {
        padding: 0 0 0 12px;
        height: 100%;
        max-height: 500px;

        .table {
            height: calc(100% - 45px);

            /deep/.el-table {

                .el-button--text {
                    padding: 0;
                }

                td,
                th {
                    padding: 6px 0;

                    .cell {
                        font-size: 14px;
                        padding: 0 6px;

                        span {
                            font-size: 14px;
                        }
                    }
                }

                .plan-row {
                    td {
                        background-color: pink !important;
                    }

                    &.hover-row {
                        td {
                            background-color: pink !important;
                        }
                    }
                }
            }
        }

        .main_footer {
            height: 45px;
            display: flex;
            align-items: center;

            .text {
                color: #F56C6C;
                padding: 0 4px;
                font-size: 14px;
                font-weight: bolder;
            }

            .el-button {
                transform: translate(-50%, 0);
            }
        }
    }

    /deep/.el-select-dropdown__item {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
}
</style>